import React from 'react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-secondary-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">О компании ТОО «KazPolimerPlast»</h1>
          <p className="text-xl text-gray-600 dark:text-secondary-300">
            Компания специализируется на выпуске труб полиэтиленовых для систем водоснабжения, канализации, газоснабжения
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16">
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-6">История компании</h2>
            <p className="text-gray-600 dark:text-secondary-300 mb-4">
              ТОО «KazPolimerPlast» была основана в феврале 2010 года в городе Уральск, 
              Республика Казахстан, с целью производства высококачественных полиэтиленовых труб.
            </p>
            <p className="text-gray-600 dark:text-secondary-300 mb-4">
              Компания специализируется на выпуске труб полиэтиленовых для систем водоснабжения, 
              канализации, газоснабжения, а также труб с соэкструзионными слоями и фитингов.
            </p>
            <p className="text-gray-600 dark:text-secondary-300">
              Производство осуществляется на современном оборудовании от ведущих мировых 
              производителей с применением передовых технологий.
            </p>
          </div>
          <div className="bg-white dark:bg-secondary-800 p-6 sm:p-8 rounded-lg shadow-lg">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-4">Производственные мощности</h3>
            <ul className="space-y-3">
              <li className="flex items-center">
                <span className="text-green-500 mr-3">✓</span>
                <span className="text-gray-900 dark:text-white">4 экструзионные линии</span>
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3">✓</span>
                <span className="text-gray-900 dark:text-white">Производственная мощность 6000 тонн в год</span>
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3">✓</span>
                <span className="text-gray-900 dark:text-white">Диаметр труб от 20 до 1200 мм</span>
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3">✓</span>
                <span className="text-gray-900 dark:text-white">Современное оборудование от ведущих мировых производителей</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16">
          <div className="bg-white dark:bg-secondary-800 p-6 sm:p-8 rounded-lg shadow-lg text-center">
            <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-4 break-words">Сертификат системы менеджмента качества</h3>
            <p className="text-gray-600 dark:text-secondary-300">
              Система менеджмента качества соответствует требованиям международного стандарта ISO 9001
            </p>
          </div>
          <div className="bg-white dark:bg-secondary-800 p-6 sm:p-8 rounded-lg shadow-lg text-center">
            <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-4 break-words">Сертификат системы экологического менеджмента</h3>
            <p className="text-gray-600 dark:text-secondary-300 text-sm sm:text-base">
              Система экологического менеджмента соответствует стандарту ISO 14001
            </p>
          </div>
          <div className="bg-white dark:bg-secondary-800 p-6 sm:p-8 rounded-lg shadow-lg text-center">
            <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 dark:text-white mb-4 break-words">Сертификат системы профессиональной безопасности</h3>
            <p className="text-gray-600 dark:text-secondary-300">
              Система менеджмента профессиональной безопасности и здоровья
            </p>
          </div>
        </div>

        <div className="bg-white dark:bg-secondary-800 p-8 rounded-lg shadow-lg">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-6 text-center">Высококвалифицированный персонал</h2>
          <p className="text-gray-600 dark:text-secondary-300 text-center text-lg">
            Наша команда состоит из высококвалифицированного инженерно-технических работников 
            с многолетним опытом работы в области производства полиэтиленовых труб. 
            Современные технологии и постоянное совершенствование производственных процессов 
            позволяют нам выпускать продукцию высочайшего качества.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;